/**
 * Pricing and Surcharge Utilities for Pallywear
 */

export const getSizeExtraAmount = (size) => {
  const s = (size || '').toUpperCase().trim();
  if (s === '3XL') return 50;
  if (s === '4XL') return 100;
  if (s === '5XL') return 150;
  return 0;
};

export const isExtraCostSize = (size) => {
  return getSizeExtraAmount(size) > 0;
};
